(function() {
  'use strict';

  angular.module('cfn').directive('dTabContent', function() {
    return {
      require: '^dTabContainer',
      restrict: 'E',
      transclude: true,
      scope: {
        index: '@'
      },
      template:
        '<div ng-transclude ng-if="tabsCtrl.scope.activeIndex === index"></div>',
      link: function(scope, element, attrs, tabsCtrl) {
        scope.tabsCtrl = tabsCtrl;
      }
    };
  });
})();
